import { Button, Form, Row, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useMemo } from "react";
import { FormInstance, Rule } from "antd/es/form";
import { useDownload } from "../hooks/useDownload";
import { TemplateItem } from "../../../../types/Template";
import { UploadValidationErrors } from "./UploadValidationErrors";
import { useUploadFile } from "../../../../lib/hooks/useUploadFile";
import { useUploadFileRule } from "../../../../lib/hooks/useUploadFileRule";

type UploadFileProps = {
  form: FormInstance;
  data: TemplateItem | null;
  errors: string[];
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  onValidationFail: (value: string[]) => void;
};

export const UploadFile = ({
  form,
  data,
  errors,
  setIsDisabled,
  onValidationFail,
}: UploadFileProps) => {
  const { onDownload } = useDownload();

  const onDownlaodClick = useCallback(() => {
    data && onDownload(data.id, data.fileName);
  }, [data, onDownload]);

  const { rule } = useUploadFileRule();

  const fileRule: Rule[] = useMemo(() => {
    return [
      ...rule,
      { validateTrigger: "onSubmit", required: true, type: "array" },
    ];
  }, [rule]);

  useEffect(() => {
    const files = form.getFieldValue("file");

    if (files) {
      const val = [...files];

      if (errors.length > 0) {
        val[0].status = "error";
      }

      form.setFieldValue("file", val);
    }
  }, [form, errors]);

  const { upload } = useUploadFile(3, setIsDisabled);

  const onChange = useCallback(() => onValidationFail([]), [onValidationFail]);

  return (
    <Row className="position-relative">
      <Form.Item
        label="Template"
        name="file"
        className="mb-2 w-100"
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={fileRule}
      >
        <Upload
          listType="picture"
          customRequest={upload}
          maxCount={1}
          previewFile={async () => ""}
          showUploadList={{ showDownloadIcon: true }}
          onDownload={onDownlaodClick}
          onChange={onChange}
        >
          <Button icon={<UploadOutlined />} shape="round">
            Upload DOCX
          </Button>
        </Upload>
      </Form.Item>
      {errors.length > 0 && <UploadValidationErrors errors={errors} />}
    </Row>
  );
};
